/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExternalSystemEnum } from './externalSystemEnum';
import { AvailabilityModeEnum } from './availabilityModeEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface AvailabilityScheduleCreateRequest { 
    weekdays: Array<number>;
    weekInterval?: number;
    availabilityMode?: AvailabilityModeEnum;
    externalSystem?: ExternalSystemEnum | null;
    fromTime: string;
    toTime: string;
    startDate: string;
    endDate?: string;
    ignoreWarnings?: boolean;
}
export namespace AvailabilityScheduleCreateRequest {
}

export const AvailabilityScheduleCreateRequest_weekdays_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilityScheduleCreateRequest_weekInterval_Validators: ValidatorFn[] =
    [  Validators.min(1), Validators.max(8),];

export const AvailabilityScheduleCreateRequest_availabilityMode_Validators: ValidatorFn[] =
    [ ];

export const AvailabilityScheduleCreateRequest_externalSystem_Validators: ValidatorFn[] =
    [ ];

export const AvailabilityScheduleCreateRequest_fromTime_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilityScheduleCreateRequest_toTime_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilityScheduleCreateRequest_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilityScheduleCreateRequest_endDate_Validators: ValidatorFn[] =
    [ ];

export const AvailabilityScheduleCreateRequest_ignoreWarnings_Validators: ValidatorFn[] =
    [ ];


